<template>
  <div class="legal-texts-new-view">
    <h1>{{$t('titles.new')}}</h1>
    <legal-text-form @submit="insertLegalText"
                :errors="errors"
                :disabled="isSubmitting" />
  </div>
</template>

<script>
import LegalTextForm from '@/components/LegalTextForm';
import insertLegalTextMutation from '@/api/mutations/insert-legal-text.graphql';
import Submittable from '@/mixins/Submittable';
import Toast from '@/helpers/Toast';
import View from '@/mixins/View';

export default {
  name: 'legal-texts-new-view',
  mixins: [
    Submittable,
    View,
  ],
  components: {
    LegalTextForm,
  },
  computed: {
    breadcrumbs() {
      return [
        {
          key: 'new',
          route: { name: 'new-legal-text' },
        },
      ];
    },
  },
  methods: {
    async insertLegalText(legalText) {
      const operation = await this.submitWithMutation({
        mutation: insertLegalTextMutation,
        variables: { legalText },
      });
      if (operation.isValid) {
        const legalTextName = operation.legalText.name;
        const message = this.$t('toasts.created', { name: legalTextName });
        Toast.success(message);
        this.$router.push({
          name: 'legal-texts',
          query: { sort: 'updatedAt,desc' },
        });
      }
    },
  },
  i18n: {
    messages: {
      de: {
        titles: {
          new: 'Rechtstext erstellen',
        },
        toasts: {
          created: 'Rechtstext erstellt: {name}',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// NewView.vue?05c7b57e